import { hideElement, bindAll } from "./dom.js";

export function initAnnouncement() {
    const bar = document.querySelector(".site-announcement");
    if (!bar) return;

    bindAll('[data-action="close-announcement"]', 'click', handleClose);

    function handleClose() {
        hideElement(bar);
    }
}
